import script from "./ProgramTasksList.vue?vue&type=script&setup=true&lang=js"
export * from "./ProgramTasksList.vue?vue&type=script&setup=true&lang=js"

import "./ProgramTasksList.vue?vue&type=style&index=0&id=560f42af&scoped=true&lang=css"

import exportComponent from "/home/dev/g-nti/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-560f42af"]])

export default __exports__